import { all, takeEvery, put, call } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');

// configuraciones por defecto que serán aplicadas a cada petición.
gaxios.instance.defaults = {
    baseURL: siteConfig.siteUrl.API_URL,
}
const headers = {
  Authorization: localStorage.getItem('access_token'),
  AuthId: localStorage.getItem('id_token'),
}

export function* saveMovAux(action) {
    try {
        let ULRDestino = "api/movCajaAux/";
        let metodo = "POST";
        const res = yield call(gaxios.request, {
            url: ULRDestino,
            data: {
                ...action.movCajaAux,
                isContadorProduction: process.env.NODE_ENV === 'production' ? true : false
            },
            method: metodo,
            headers: headers,
        });
        if (res.data.success) {
            yield put({
                type: actions.GET_MOV_AUX,
            });
            notification('success', res.data.msg);
            yield action.history.push('lista-caja-aux');
        } else {
            notification('error', res.data.msg);
        }
    } catch (err) {
        const message =
            err.response?.data?.msg ||
            err.response?.data?.message ||
            err.message;
        notification('error', message);
    }
}

export function* getMovAuxSaga(action) {
    try {
        let ULRDestino = `api/movCajaAux/${action.query ? "?" + action.query : ""}`;
        let metodo = "GET";
        const res = yield call(gaxios.request, {
            url: ULRDestino,
            method: metodo,
            headers: headers,
        });
        if (res.data.success) {
            yield put({
                type: actions.UPDATE_MOVS_AUX,
                payload: res.data.movimientosCajaAux,
            });
        } else {
            notification('error', res.data.msg);
        }

        if (res.data.paginationInfo) {
            yield put({
                type: actions.SET_PAGINATION_MOVS_INFO,
                payload: res.data.paginationInfo,
            });
        }
    } catch (err) {
        const message =
            err.response?.data?.msg ||
            err.response?.data?.message ||
            err.message;

        notification('error', message);
    }
}

export function* getInformesMovAux(action) {
    try {
        let query = action.startDate && action.endDate
            ? `?fechaInicio=${action.startDate}&fechaFin=${action.endDate}`
            : "";
        let ULRDestino = `api/movCajaAux/reportes${query}`;
        let metodo = "GET";
        const res = yield call(gaxios.request, {
            url: ULRDestino,
            method: metodo,
            headers: headers,
        });
        if (res.data.success) {
            yield put({
                type: actions.GET_INFORMES_MOV_AUX_SUCCESS,
                payload: res.data,
            });
        } else {
            notification('error', res.data.msg);
        }

    } catch (err) {
        const message =
            err.response?.data?.msg ||
            err.response?.data?.message ||
            err.message;

        notification('error', message);
    }
}


export function* updateMovAux(action) {
    try {
        let ULRDestino = "api/movCajaAux/" + action.id;
        let metodo = "PUT";
        const res = yield call(gaxios.request, {
            url: ULRDestino,
            data: action.info,
            method: metodo,
            headers: headers,
        });
        if (res.data.success) {
            notification('success', res.data.msg);
            yield put({
                type: actions.GET_MOV_AUX, // vuelve a obtener la lista
            });
        } else {
            notification('error', res.data.msg);
        }
    } catch (err) {
        const message =
            err.response?.data?.msg ||
            err.response?.data?.message ||
            err.message;

        notification('error', message);
    }
}



export function* deleteSoftMovAux(action) {
    try {
        let ULRDestino = "api/movCajaAux/soft-delete/" + action.id;
        let metodo = "PUT";
        const res = yield call(gaxios.request, {
            url: ULRDestino,
            method: metodo,
            headers: headers,
        });
        if (res.data.success) {
            notification('success', res.data.msg)
            yield put({
                type: actions.GET_MOV_AUX,
            });
        } else {
            notification('error', res.data.msg);
        }
    } catch (err) {
        const message =
            err.response?.data?.msg ||
            err.response?.data?.message ||
            err.message;

        notification('error', message);
    }
}


export default function* rootSaga() {
    yield all([
        takeEvery(actions.SAVE_MOV_AUX, saveMovAux),
        takeEvery(actions.GET_MOV_AUX, getMovAuxSaga),
        takeEvery(actions.UPDATE_MOV_AUX_REQUEST, updateMovAux),
        takeEvery(actions.DELETE_SOFT_MOX_AUX, deleteSoftMovAux),
        takeEvery(actions.GET_INFORMES_MOV_AUX_REQUEST, getInformesMovAux),
    ]);
}
